import get from 'lodash/get';

export default (state, namespaces) => {
  const blocks = get(state.page, 'data.blocks', []);
  return blocks.filter(block => namespaces.includes(block.type));
};
